import React, { useState, useEffect, useRef } from "react";
import Modal from "react-modal";
import "./NoticeRegisterPopup.css";
import Swal from "sweetalert2";
import Editor from "../../../../components/Dashboard/Editor";

// 필수: 모달을 사용할 DOM 요소 설정

function NoticeRegister({ isOpen, onClose, onSave }) {
  const initialNoticeRegData = {
    title: "",
    contents: "",
    files: "",
    gubun: "N",
  };

  const [noticeRegData, setNoticeRegData] = useState({ ...initialNoticeRegData });

  // 에디터 ref 선언
  const editorRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNoticeRegData({
      ...noticeRegData,
      [name]: value,
    });
  };

  useEffect(() => {
    if (!isOpen) {
      setNoticeRegData({ ...initialNoticeRegData });
    }
  }, [isOpen]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
  };

  const handleGosiQuillChange = (content, delta, source, editor) => {
    noticeRegData.contents = content;
  };

  const handleSaveClick = async () => {
    // 저장 시점에 현재 에디터 내용을 가져와서 저장
    let updateContents = "";

    if (editorRef.current) {
      const html = editorRef.current.getHTML();
      updateContents = html;
    }

    const fileInput = document.getElementById("noRegFileInputId").files[0];

    if (noticeRegData.title.trim() === "") {
      Swal.fire("알림", "제목을 입력해 주세요.", "warning");
      return;
    }

    if (updateContents === "" || updateContents === "<p><br></p>") {
      Swal.fire("알림", "고시내용을 입력해 주세요.", "warning");
      return;
    }

    const formNoticeRegData = new FormData();
    formNoticeRegData.append("title", noticeRegData.title.trim());
    formNoticeRegData.append("contents", updateContents);
    formNoticeRegData.append("gubun", "N");

    if (fileInput !== undefined) {
      formNoticeRegData.append("files", fileInput);
    }

    onSave(formNoticeRegData);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Notice Reg Popup"
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1000,
        },
        content: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          border: "1px solid #ccc",
          background: "white",
          borderRadius: "4px",
          width: "900px", // 모달의 너비를 조정해 필요한 경우 수정
          height: "620px",
        },
      }}
    >
      <div className="notice-custom-modal-header">
        <h2>공지 등록</h2>
      </div>
      <div className="notice-custom-modal-content-flex">
        <div className="notice-input-container" style={{ diplay: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <label htmlFor="noticeTitle">제목</label>
          <div className="notice-input-row">
            <input className="notice-title" type="text" name="title" value={noticeRegData.title} onChange={handleChange} placeholder="제목을 입력해 주세요." />
          </div>
          <label className="i-label">첨부파일</label>
          <div className="notice-input-row notice-attachments">
            <input type="file" id="noRegFileInputId" name="noRegFileInput" onChange={handleFileChange} />
            {/*noticeRegister줄여서 noreg*/}
          </div>
        </div>
      </div>
      <div className="notice-custom-modal-content-align-right">
        <div className="notice-quill-container">
          <div className="notice-input-row" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", fontWeight: "400" }}>
            <label htmlFor="hospitalInfo" style={{ marginBottom: "5px" }}>
              공지 내용
            </label>
            <Editor ref={editorRef} readOnly={false} initialHTML={noticeRegData.contents} placeholder="등록할 공지 내용을 입력하세요." />
          </div>
        </div>
        <div className="notice-custom-button-container">
          <button className="dashboard-content-button popup-button" onClick={handleSaveClick}>
            저장
          </button>
          <button className="dashboard-content-button red-button popup-button" onClick={onClose}>
            취소
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default NoticeRegister;
